import { render } from "./EditPermissionGroup.vue?vue&type=template&id=a92e6f9e&scoped=true&ts=true"
import script from "./EditPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./EditPermissionGroup.vue?vue&type=script&lang=ts"

import "./EditPermissionGroup.vue?vue&type=style&index=0&id=a92e6f9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92e6f9e"]])

export default __exports__